<script>
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: { WootMessageEditor, NextButton },
  props: {
    modelValue: {
      type: Object,
      default: () => null,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      integratorsOptions: [{ value: 'pipefy', label: 'Pipefy' }],
      integrator: '',
      dealName: '',
      pipeCode: '',
      currentStage: '',
      fields: [],
    };
  },
  mounted() {
    this.integrator = this.modelValue?.[0]?.integrator || '';
    this.dealName = this.modelValue?.[0]?.deal_name || '';
    this.pipeCode = this.modelValue?.[0]?.pipe_code || '';
    this.currentStage = this.modelValue?.[0]?.current_stage || '';
    this.fields = this.modelValue?.[0]?.fields
      ? this.modelValue[0].fields.map(field => ({ ...field }))
      : [];
    this.updateValue();
  },
  methods: {
    isFilled(value) {
      return typeof value === 'string' && value.trim() !== '';
    },
    updateValue() {
      const isValid =
        this.isFilled(this.integrator) &&
        this.isFilled(this.dealName) &&
        this.isFilled(this.pipeCode) &&
        this.isFilled(this.currentStage) &&
        this.fields.every(
          f => this.isFilled(f.field_name) && this.isFilled(f.field_value)
        );

      if (!isValid) {
        this.$emit('update:modelValue', []);
        return;
      }

      this.$emit('update:modelValue', {
        integrator: this.integrator,
        deal_name: this.dealName,
        pipe_code: this.pipeCode,
        current_stage: this.currentStage,
        fields: this.fields,
      });
    },
    addField() {
      this.fields.push({ field_name: '', field_value: '' });
      this.updateValue();
    },
    removeField(index) {
      this.fields.splice(index, 1);
      this.updateValue();
    },
  },
};
</script>

<template>
  <div>
    <div>
      <select v-model="integrator" class="mt-1 mb-0" @change="updateValue">
        <option value="" disabled>Integrador</option>
        <option
          v-for="option in integratorsOptions"
          :key="option.value"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
      <template v-if="integrator">
        <WootMessageEditor
          v-model="dealName"
          enable-variables
          :focus-on-mount="false"
          placeholder="Nome do negócio"
          class="editor-input"
          @update:model-value="updateValue"
        />
        <input
          v-model="pipeCode"
          type="text"
          placeholder="ID do funil"
          class="!mb-1"
          @input="updateValue"
        />
        <input
          v-model="currentStage"
          type="text"
          placeholder="ID da etapa"
          class="!mb-1"
          @input="updateValue"
        />
        <span v-if="fields.length" class="text-sm">Campos adicionais</span>
        <div v-for="(field, index) in fields" :key="index" class="field-row">
          <input
            v-model="field.field_name"
            type="text"
            placeholder="Nome do campo"
            class="field-name-input"
            @input="updateValue"
          />
          <WootMessageEditor
            v-model="field.field_value"
            enable-variables
            :focus-on-mount="false"
            placeholder="Valor do campo"
            class="editor-input field-value-editor"
            @update:model-value="updateValue"
          />
          <NextButton
            ghost
            slate
            sm
            icon="i-lucide-x"
            @click="removeField(index)"
          />
        </div>
        <NextButton
          faded
          teal
          sm
          icon="i-lucide-plus"
          label="Adicionar campo"
          class="mt-2 w-auto"
          @click="addField"
        />
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.editor-input {
  @apply block w-full min-w-0 max-w-full mt-1 mx-0 mb-1;

  ::v-deep .ProseMirror-menubar-wrapper {
    @apply h-[2.4375rem] px-2 py-1.5
           border border-solid border-slate-200 dark:border-slate-600
           rounded-md bg-white dark:bg-slate-900
           text-slate-800 dark:text-slate-100
           w-full min-w-0 max-w-full;
  }

  ::v-deep .ProseMirror {
    @apply min-h-0 max-h-full p-0 border-0 bg-transparent overflow-x-auto overflow-y-hidden whitespace-nowrap;

    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }

    p {
      @apply my-0 text-base font-normal whitespace-nowrap;
    }

    // .empty-node::before {
    //   color: currentColor !important;
    //   @apply font-normal;
    // }
  }
}

.field-row {
  @apply flex gap-1 items-start mt-1;
}

.field-name-input {
  margin-bottom: 0px !important;
  width: 33.333333% !important;

  @apply flex-shrink-0;
}

.field-value-editor {
  margin-bottom: 0px !important;

  @apply flex-1 min-w-0 mt-0;
}

::v-deep .ProseMirror-menubar {
  @apply hidden;
}
</style>
